import React, { useState } from 'react'
import { canAccessSection, getRoleName, canViewSectionByPlatform } from '../utils/rolePermissions'

const Sidebar = ({
  currentPage,
  setCurrentPage,
  permissions,
  onLogout,
  currentUser,
  isMobile,
  isCollapsed,
  onClose
}) => {
  const [collapsedSections, setCollapsedSections] = useState({})

  const toggleSection = (sectionId) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }))
  }

  const handleMenuClick = (pageId) => {
    setCurrentPage(pageId)
    if (isMobile && onClose) {
      onClose()
    }
  }

  const menuSections = [
    {
      id: 'main',
      label: 'Principal',
      items: [
        {
          id: 'dashboard',
          label: 'Dashboard',
          icon: (
            <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z'
              />
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M8 5a2 2 0 012-2h4a2 2 0 012 2v3H8V5z'
              />
            </svg>
          ),
          show: permissions.canViewDashboard
        },
        {
          id: 'clients',
          label: 'Expedientes',
          icon: (
            <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
              />
            </svg>
          ),
          show: canAccessSection(currentUser.role, 'clients')
        },
        {
          id: 'allTasks',
          label: 'Tareas',
          icon: (
            <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4'
              />
            </svg>
          ),
          show: true
        },
        {
          id: 'reminds',
          label: 'Reminds',
          icon: (
            <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9'
              />
            </svg>
          ),
          show: true
        },
        {
          id: 'adsRequests',
          label: 'Solicitudes de Ads',
          shortLabel: 'Solicitudes Ads',
          icon: (
            <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
              />
            </svg>
          ),
          show: permissions.canViewGoogleAds
        }
      ]
    },
    {
      id: 'adsMonitoring',
      label: 'Ads Monitoreo',
      items: [
        {
          id: 'adsMonitoringSection',
          label: 'Monitoreo y Alertas',
          shortLabel: 'Ads',
          icon: (
            <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
              />
            </svg>
          ),
          show: permissions.canViewGoogleAds || permissions.canViewMetaAds
        }
      ]
    },
    {
      id: 'googleAdsOld',
      label: 'Google Ads',
      // Add a show property for the main section based on canViewGoogleAds
      show: permissions.canViewGoogleAds,
      subsections: [
        {
          id: 'operations',
          label: 'Operaciones',
          items: [
            {
              id: 'budgetOperations',
              label: 'Aumento de Ppto Google',
              shortLabel: 'Aumento Ppto',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'budget-operations')
            },
            {
              id: 'campaignTracking',
              label: 'Seguimiento de Campañas',
              shortLabel: 'Campañas',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'campaign-tracking')
            },
            {
              id: 'balanceReduction',
              label: 'Clientes que Bajan Saldo',
              shortLabel: 'Bajan Saldo',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M13 17h8m0 0V9m0 8l-8-8-4 4-6-6'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'balance-reduction')
            }
          ]
        },
        {
          id: 'problems',
          label: 'Problemas',
          items: [
            {
              id: 'noContactClients',
              label: 'Bajaron o Sin Contactos',
              shortLabel: 'Sin Contactos',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L12 12m6.364 6.364L12 12m0 0L5.636 5.636M12 12l6.364 6.364M12 12L5.636 5.636'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'no-contact-clients')
            },
            {
              id: 'noTrafficClients',
              label: 'Sin Tráfico',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'no-traffic-clients')
            },
            {
              id: 'excessJunkClients',
              label: 'Exceso de Basura',
              shortLabel: 'Exceso Basura',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'excess-junk-clients')
            },
            {
              id: 'cpcTrafficClients',
              label: 'Aumento CPC y ↓ Tráfico',
              shortLabel: 'CPC/Tráfico',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'cpc-traffic-clients')
            },
            {
              id: 'conversionDrops',
              label: 'Conversiones Caídas',
              shortLabel: 'Conversiones',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M13 17h8m0 0V9m0 8l-8-8-4 4-6-6'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'conversion-drops')
            },
            {
              id: 'verifications',
              label: 'Verificaciones',
              shortLabel: 'Verificaciones',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'verifications')
            },
            {
              id: 'noAnswerClients',
              label: 'Clientes que No Contestan',
              shortLabel: 'No Contestan',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 3l1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17l-1.5-1.5M9 9l10.5 10.5M15 15l-3-3m3 3l-3-3m-6.75 0L7.5 13.5M12 12L9 9'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'no-answer-clients')
            }
          ]
        }
      ]
    },
    {
      id: 'meta',
      label: 'Meta',
      subsections: [
        {
          id: 'meta-operations',
          label: 'Operaciones',
          items: [
            {
              id: 'metaBudgetIncrease',
              label: 'Aumento de Ppto Meta',
              shortLabel: 'Aumento Ppto',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'meta-budget-increase')
            },
            {
              id: 'metaCampaignTracking',
              label: 'Seguimiento de Campañas Meta',
              shortLabel: 'Campañas Meta',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'meta-campaign-tracking')
            },
            {
              id: 'metaBalanceReduction',
              label: 'Clientes que Bajan Saldo Meta',
              shortLabel: 'Bajan Saldo Meta',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M13 17h8m0 0V9m0 8l-8-8-4 4-6-6'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'meta-balance-reduction')
            }
          ]
        },
        {
          id: 'meta-problems',
          label: 'Problemas',
          items: [
            {
              id: 'metaNoContact',
              label: 'Bajaron o Sin Contactos Meta',
              shortLabel: 'Sin Contactos Meta',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L12 12m6.364 6.364L12 12m0 0L5.636 5.636M12 12l6.364 6.364M12 12L5.636 5.636'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'meta-no-contact')
            },
            {
              id: 'metaCostIncrease',
              label: 'Aumento de Costo por Mensaje',
              shortLabel: 'Costo Mensaje',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'meta-cost-increase')
            },
            {
              id: 'metaVerifications',
              label: 'Verificación de Cuentas Meta',
              shortLabel: 'Verificaciones Meta',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'meta-verifications')
            },
            {
              id: 'metaNoAnswer',
              label: 'Clientes que No Contestan Meta',
              shortLabel: 'No Contestan Meta',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 3l1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17l-1.5-1.5M9 9l10.5 10.5M15 15l-3-3m3 3l-3-3m-6.75 0L7.5 13.5M12 12L9 9'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'meta-no-answer')
            },
            {
              id: 'metaBudgetReview',
              label: 'Revisión de Presupuesto Meta',
              shortLabel: 'Presupuesto Meta',
              icon: (
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z'
                  />
                </svg>
              ),
              show: canAccessSection(currentUser.role, 'meta-budget-review')
            }
          ]
        }
      ]
    },
    {
      id: 'admin',
      label: 'Administración',
      items: [
        {
          id: 'admin',
          label: 'Panel de Admin',
          shortLabel: 'Admin',
          icon: (
            <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z'
              />
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'
              />
            </svg>
          ),
          show: permissions.canAccessAdminPanel
        }
      ]
    }
  ]

  // Filtrar secciones que tienen al menos un item visible y según especialidad de plataforma
  const visibleSections = menuSections.filter((section) => {
    // Verificar si la sección debe mostrarse según la especialidad de plataforma
    const userPlatformSpecialty = currentUser.platform_specialty || 'both'

    // Secciones que requieren filtrado por plataforma
    const googleAdsSectionIds = ['adsMonitoreo', 'googleAdsOld']
    const metaSectionIds = ['meta']

    // Si el usuario tiene especialidad específica, filtrar secciones
    if (userPlatformSpecialty === 'google_ads' && metaSectionIds.includes(section.id)) {
      return false // Usuario de Google Ads no puede ver secciones de Meta
    }

    if (userPlatformSpecialty === 'meta' && googleAdsSectionIds.includes(section.id)) {
      return false // Usuario de Meta no puede ver secciones de Google Ads
    }

    // Verificar si la sección tiene items visibles
    if (section.items) {
      return section.items.some((item) => {
        if (!item.show) return false

        // Aplicar filtrado adicional por especialidad de plataforma a nivel de item
        return canViewSectionByPlatform(userPlatformSpecialty, item.id)
      })
    }

    if (section.subsections) {
      return section.subsections.some((subsection) =>
        subsection.items.some((item) => {
          if (!item.show) return false

          // Aplicar filtrado adicional por especialidad de plataforma a nivel de item
          return canViewSectionByPlatform(userPlatformSpecialty, item.id)
        })
      )
    }

    return false
  })

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z'
          />
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M8 5a2 2 0 012-2h4a2 2 0 012 2v3H8V5z'
          />
        </svg>
      ),
      show: permissions.canViewDashboard
    },
    {
      id: 'clients',
      label: 'Clientes',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
          />
        </svg>
      ),
      show: true
    },
    {
      id: 'allTasks',
      label: 'Tareas',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4'
          />
        </svg>
      ),
      show: true
    },
    {
      id: 'budgetOperations',
      label: 'Aumento de Ppto Google',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1'
          />
        </svg>
      ),
      show: permissions.canViewBudgetOperations
    },
    {
      id: 'campaignTracking',
      label: 'Seguimiento de Campañas Nuevas',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
          />
        </svg>
      ),
      show: permissions.canViewCampaignTracking
    },
    {
      id: 'balanceReduction',
      label: 'Clientes que Bajan Saldo',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M13 17h8m0 0V9m0 8l-8-8-4 4-6-6'
          />
        </svg>
      ),
      show: permissions.canViewBalanceReduction
    },
    {
      id: 'noContactClients',
      label: 'Bajaron o Sin Contactos',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L12 12m6.364 6.364L12 12m0 0L5.636 5.636M12 12l6.364 6.364M12 12L5.636 5.636'
          />
        </svg>
      ),
      show: permissions.canViewNoContactClients
    },
    {
      id: 'noTrafficClients',
      label: 'Sin Tráfico',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
          />
        </svg>
      ),
      show: permissions.canViewNoTrafficClients
    },
    {
      id: 'excessJunkClients',
      label: 'Exceso de Basura',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'
          />
        </svg>
      ),
      show: permissions.canViewExcessJunkClients
    },
    {
      id: 'cpcTrafficClients',
      label: '📈 Aumento CPC y ↓ Tráfico',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
          />
        </svg>
      ),
      show: permissions.canViewCpcTrafficClients
    },
    {
      id: 'conversionDrops',
      label: '📉 Conversiones Caídas',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M13 17h8m0 0V9m0 8l-8-8-4 4-6-6'
          />
        </svg>
      ),
      show: permissions.canViewConversionDrops
    },
    {
      id: 'verifications',
      label: '🔍 Verificaciones',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
          />
        </svg>
      ),
      show: permissions.canViewVerifications
    },
    {
      id: 'noAnswerClients',
      label: '📞 Clientes que No Contestan',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 3l1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17l-1.5-1.5M9 9l10.5 10.5M15 15l-3-3m3 3l-3-3m-6.75 0L7.5 13.5M12 12L9 9'
          />
        </svg>
      ),
      show: permissions.canViewNoAnswerClients
    },
    {
      id: 'admin',
      label: 'Administración',
      icon: (
        <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z'
          />
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'
          />
        </svg>
      ),
      show: permissions.canAccessAdminPanel
    }
  ]

  return (
    <div className='bg-white shadow-lg h-full flex flex-col overflow-hidden'>
      {/* Header con logo y botón de cerrar para móvil */}
      <div
        className={`border-b border-gray-200 flex-shrink-0 ${
          isCollapsed ? 'px-2 py-3' : 'responsive-padding-x responsive-padding-y'
        }`}
      >
        <div className='flex items-center justify-between'>
          <div
            className={`flex items-center min-w-0 flex-1 ${
              isCollapsed ? 'justify-center' : 'space-x-3'
            }`}
          >
            {isCollapsed ? (
              // Logo contraído - Solo el símbolo circular
              <img src='/favicon.png' alt='Doctorweb' className='flex-shrink-0 h-8 w-8' />
            ) : (
              // Logo expandido - Logo completo adaptado para el sidebar
              <img
                src='/logo.png'
                alt='Doctorweb'
                className='flex-shrink-0 h-8 w-auto max-w-full object-contain'
                style={{ maxHeight: '32px' }}
              />
            )}
          </div>

          {/* Botón de cerrar para móvil */}
          {isMobile && onClose && (
            <button
              onClick={onClose}
              className='p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors duration-200 ml-2'
              aria-label='Cerrar menú'
            >
              <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  d='M6 18L18 6M6 6l12 12'
                />
              </svg>
            </button>
          )}
        </div>
      </div>

      {/* Navegación por secciones - Responsiva con modo colapsado */}
      <nav className='flex-1 overflow-y-auto'>
        <div className={`py-2 sm:py-4 ${isCollapsed ? 'px-2' : 'responsive-padding-x'}`}>
          {isCollapsed ? (
            // Modo colapsado: solo iconos
            <div className='space-y-2'>
              {visibleSections.map((section) => {
                if (section.items) {
                  return section.items
                    .filter((item) => item.show)
                    .map((item) => (
                      <button
                        key={item.id}
                        onClick={() => handleMenuClick(item.id)}
                        className={`
                        w-full flex items-center justify-center p-3 rounded-xl transition-all duration-200
                        ${
                          currentPage === item.id
                            ? 'bg-gradient-to-r from-blue-50 to-blue-100 text-blue-700 shadow-sm border-l-4 border-blue-600'
                            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 hover:shadow-sm'
                        }
                      `}
                        title={item.label}
                      >
                        <span
                          className={`${
                            currentPage === item.id ? 'text-blue-600' : 'text-gray-400'
                          }`}
                        >
                          {item.icon}
                        </span>
                      </button>
                    ))
                }
                if (section.subsections) {
                  return section.subsections.map((subsection) =>
                    subsection.items
                      .filter((item) => item.show)
                      .map((item) => (
                        <button
                          key={item.id}
                          onClick={() => handleMenuClick(item.id)}
                          className={`
                          w-full flex items-center justify-center p-3 rounded-xl transition-all duration-200
                          ${
                            currentPage === item.id
                              ? 'bg-gradient-to-r from-blue-50 to-blue-100 text-blue-700 shadow-sm border-l-4 border-blue-600'
                              : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 hover:shadow-sm'
                          }
                        `}
                          title={item.label}
                        >
                          <span
                            className={`${
                              currentPage === item.id ? 'text-blue-600' : 'text-gray-400'
                            }`}
                          >
                            {item.icon}
                          </span>
                        </button>
                      ))
                  )
                }
                return null
              })}
            </div>
          ) : (
            // Modo expandido: secciones completas
            visibleSections.map((section) => (
              <div key={section.id} className='mb-4 sm:mb-6'>
                {/* Encabezado de sección */}
                <div className='flex items-center justify-between mb-2 sm:mb-3'>
                  <h3 className='responsive-text-xs font-semibold text-gray-500 uppercase tracking-wider px-2'>
                    {section.label}
                  </h3>
                  {((section.items && section.items.length > 3) || section.subsections) && (
                    <button
                      onClick={() => toggleSection(section.id)}
                      className='p-1 text-gray-400 hover:text-gray-600 rounded transition-colors duration-200'
                      aria-label={`${collapsedSections[section.id] ? 'Expandir' : 'Contraer'} ${
                        section.label
                      }`}
                    >
                      <svg
                        className={`w-4 h-4 transform transition-transform duration-200 ${
                          collapsedSections[section.id] ? 'rotate-180' : ''
                        }`}
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M19 9l-7 7-7-7'
                        />
                      </svg>
                    </button>
                  )}
                </div>

                {/* Contenido de la sección */}
                <div
                  className={`transition-all duration-300 ${
                    collapsedSections[section.id]
                      ? 'max-h-0 overflow-hidden opacity-0'
                      : 'max-h-none opacity-100'
                  }`}
                >
                  {section.items ? (
                    // Sección con items directos
                    <div className='space-y-1 sm:space-y-2'>
                      {section.items
                        .filter((item) => item.show)
                        .map((item) => (
                          <button
                            key={item.id}
                            onClick={() => handleMenuClick(item.id)}
                            className={`
                            w-full flex items-center space-x-3 rounded-xl text-left transition-all duration-200
                            ${isMobile ? 'px-3 py-3' : 'px-4 py-2.5 sm:py-3'}
                            ${
                              currentPage === item.id
                                ? 'bg-gradient-to-r from-blue-50 to-blue-100 text-blue-700 shadow-sm border-l-4 border-blue-600'
                                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 hover:shadow-sm'
                            }
                          `}
                          >
                            <span
                              className={`flex-shrink-0 ${
                                currentPage === item.id ? 'text-blue-600' : 'text-gray-400'
                              }`}
                            >
                              {item.icon}
                            </span>
                            <span
                              className={`font-medium truncate ${
                                isMobile && item.shortLabel ? 'sm:hidden' : ''
                              }`}
                            >
                              {isMobile && item.shortLabel ? item.shortLabel : item.label}
                            </span>
                            {isMobile && item.shortLabel && (
                              <span className='hidden sm:inline font-medium truncate'>
                                {item.label}
                              </span>
                            )}
                          </button>
                        ))}
                    </div>
                  ) : (
                    // Sección con subsecciones
                    <div className='space-y-3'>
                      {section.subsections.map((subsection) => (
                        <div key={subsection.id}>
                          {/* Encabezado de subsección */}
                          <div className='flex items-center justify-between mb-2'>
                            <h4 className='responsive-text-xs font-medium text-gray-400 uppercase tracking-wider px-2'>
                              {subsection.label}
                            </h4>
                            <button
                              onClick={() => toggleSection(subsection.id)}
                              className='p-1 text-gray-300 hover:text-gray-500 rounded transition-colors duration-200'
                              aria-label={`${
                                collapsedSections[subsection.id] ? 'Expandir' : 'Contraer'
                              } ${subsection.label}`}
                            >
                              <svg
                                className={`w-3 h-3 transform transition-transform duration-200 ${
                                  collapsedSections[subsection.id] ? 'rotate-180' : ''
                                }`}
                                fill='none'
                                stroke='currentColor'
                                viewBox='0 0 24 24'
                              >
                                <path
                                  strokeLinecap='round'
                                  strokeLinejoin='round'
                                  strokeWidth='2'
                                  d='M19 9l-7 7-7-7'
                                />
                              </svg>
                            </button>
                          </div>

                          {/* Items de la subsección */}
                          <div
                            className={`space-y-1 transition-all duration-300 ${
                              collapsedSections[subsection.id]
                                ? 'max-h-0 overflow-hidden opacity-0'
                                : 'max-h-none opacity-100'
                            }`}
                          >
                            {subsection.items
                              .filter((item) => item.show)
                              .map((item) => (
                                <button
                                  key={item.id}
                                  onClick={() => handleMenuClick(item.id)}
                                  className={`
                                  w-full flex items-center space-x-3 rounded-xl text-left transition-all duration-200
                                  ${isMobile ? 'px-3 py-2.5 ml-4' : 'px-4 py-2 sm:py-2.5 ml-4'}
                                  ${
                                    currentPage === item.id
                                      ? 'bg-gradient-to-r from-blue-50 to-blue-100 text-blue-700 shadow-sm border-l-4 border-blue-600'
                                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 hover:shadow-sm'
                                  }
                                `}
                                >
                                  <span
                                    className={`flex-shrink-0 ${
                                      currentPage === item.id ? 'text-blue-600' : 'text-gray-400'
                                    }`}
                                  >
                                    {item.icon}
                                  </span>
                                  <span
                                    className={`font-medium truncate text-sm ${
                                      isMobile && item.shortLabel ? 'sm:hidden' : ''
                                    }`}
                                  >
                                    {isMobile && item.shortLabel ? item.shortLabel : item.label}
                                  </span>
                                  {isMobile && item.shortLabel && (
                                    <span className='hidden sm:inline font-medium truncate text-sm'>
                                      {item.label}
                                    </span>
                                  )}
                                </button>
                              ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </nav>

      {/* Información del usuario - Responsiva con modo colapsado */}
      <div className='flex-shrink-0 border-t border-gray-200 bg-gray-50'>
        <div className={isCollapsed ? 'px-2 py-3' : 'responsive-padding'}>
          {isCollapsed ? (
            // Modo colapsado: solo avatar y botón de logout
            <div className='flex flex-col items-center space-y-3'>
              <div
                className='bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center text-white font-bold shadow-lg w-10 h-10 text-sm'
                title={`${currentUser.firstName} ${currentUser.lastName}`}
              >
                {currentUser.firstName?.charAt(0)}
                {currentUser.lastName?.charAt(0)}
              </div>
              <button
                onClick={onLogout}
                className='p-2 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-xl transition-all duration-200 border border-red-200 hover:border-red-300 shadow-sm hover:shadow-md'
                title='Cerrar Sesión'
              >
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1'
                  />
                </svg>
              </button>
            </div>
          ) : (
            // Modo expandido: información completa
            <>
              {/* Avatar y info del usuario */}
              <div className='flex items-center space-x-3 mb-3 sm:mb-4'>
                <div
                  className={`bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center text-white font-bold shadow-lg ${
                    isMobile ? 'w-10 h-10 text-sm' : 'w-12 h-12 text-base'
                  }`}
                >
                  {currentUser.firstName?.charAt(0)}
                  {currentUser.lastName?.charAt(0)}
                </div>
                <div className='flex-1 min-w-0'>
                  <p className='responsive-text-sm font-semibold text-gray-900 truncate'>
                    {currentUser.firstName} {currentUser.lastName}
                  </p>
                  <p className='responsive-text-xs text-gray-500 capitalize truncate'>
                    {getRoleName(currentUser.role)}
                  </p>
                  {currentUser.role === 'standard' &&
                    currentUser.cells &&
                    currentUser.cells.length > 0 && (
                      <p className='responsive-text-xs text-gray-400 truncate mt-0.5'>
                        📍 {currentUser.cells.join(', ')}
                      </p>
                    )}
                </div>
              </div>

              {/* Botón de cerrar sesión */}
              <button
                onClick={onLogout}
                className={`
                  w-full flex items-center justify-center space-x-2 text-red-600 hover:text-red-700 
                  hover:bg-red-50 rounded-xl transition-all duration-200 font-medium
                  ${isMobile ? 'px-3 py-2.5 text-sm' : 'px-4 py-3 text-base'}
                  border border-red-200 hover:border-red-300 shadow-sm hover:shadow-md
                `}
              >
                <svg
                  className='w-4 h-4 sm:w-5 sm:h-5'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1'
                  />
                </svg>
                <span>Cerrar Sesión</span>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Sidebar
